import * as actions from "./types";

const initialState = {
  sidebarVisible: false
};

export default function(state = initialState, { type, payload = null }) {
  switch (type) {
    case actions.TOGGLE_SIDEBAR:
      return toggleSidebar(state, payload);
    default:
      return state;
  }
}

function toggleSidebar(state, payload) {
  state = Object.assign({}, state, {
    sidebarVisible: payload
  });
  return state;
}



// WEBPACK FOOTER //
// ./src/system/store/site/reducers.js